/*
 * NWF-152: Wishlist by Square glue code.
 *
 * 1. Header icon: the app injects its header widget
 *    (.Vtl-WishlistHeaderWrapper) into .header__icons--left, which is a
 *    collapsed 0-width container in this theme layout. Move it into the
 *    right icon group, directly before the cart button. Unlike the
 *    product card icons (which the app re-renders constantly, e.g. in
 *    sliders — relocation was reverted there, see nwf-wishlist-app.css
 *    section 3), the header widget is injected once on load; the
 *    observer stays active as a safety net.
 *
 * 2. Header counter (NWF-198): the app renders its badge empty or as "0"
 *    instead of removing it. CSS hides the empty one (nwf-wishlist-app.css),
 *    the literal "0" needs JS — flag it with `data-nwf-empty`.
 *
 * 3. Cart sync: the app adds wishlist items to the cart via its own
 *    AJAX call but never notifies the theme, so the drawer and the
 *    header counter stay stale until the next full page load. Hook
 *    fetch/XHR and dispatch the theme's `cart:refresh` event after any
 *    successful /cart/add request (see cart.js, onCartRefresh).
 */
(function () {
    'use strict';

    /* ---------- 1. Header icon relocation ---------- */

    function relocateHeaderIcon() {
        var wrapper = document.querySelector('.Vtl-WishlistHeaderWrapper');
        var cart = document.querySelector('.header__icons--right .header__buttons .cart-drawer-button');
        if (!wrapper || !cart) return;
        if (wrapper.parentElement === cart.parentElement) return;
        cart.parentElement.insertBefore(wrapper, cart);
    }

    /* ---------- 2. Header counter: hide at zero ---------- */

    function syncHeaderCounter() {
        var counter = document.querySelector('.header__icons--right .Vtl-WishlistHeader__HeartCounter');
        if (!counter) return;
        var value = (counter.textContent || '').trim();
        var empty = value === '' || value === '0';
        if (counter.getAttribute('data-nwf-empty') === String(empty)) return;
        counter.setAttribute('data-nwf-empty', String(empty));
    }

    /* ---------- 3. Cart sync after app add-to-cart ---------- */

    function isCartAdd(url) {
        return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    }

    /* Debounced: "Add all to cart" fires one request per item — one
       refresh after the burst is enough. Dispatched with bubbles like
       the other nwf dispatchers (see nwf-reorder.js). */
    var refreshTimer = null;
    function refreshThemeCart() {
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }, 300);
    }

    function hookFetch() {
        if (typeof window.fetch !== 'function') return;
        var original = window.fetch;
        window.fetch = function (input, init) {
            var url = typeof input === 'string' ? input : input && input.url;
            var result = original.apply(this, arguments);
            if (isCartAdd(url) && result && typeof result.then === 'function') {
                result.then(function (response) {
                    if (response && response.ok) refreshThemeCart();
                });
            }
            return result;
        };
    }

    function hookXhr() {
        var originalOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (method, url) {
            if (isCartAdd(url)) {
                this.addEventListener('load', function () {
                    if (this.status >= 200 && this.status < 300) {
                        refreshThemeCart();
                    }
                });
            }
            return originalOpen.apply(this, arguments);
        };
    }

    /* ---------- init ---------- */

    function syncHeader() {
        relocateHeaderIcon();
        syncHeaderCounter();
    }

    function init() {
        syncHeader();
        // Scoped to the header section: the app injects its widget into
        // .header__icons--left, so header-wide observation is enough and
        // avoids firing on unrelated DOM churn (sliders, countdowns, …).
        var observeRoot =
            document.querySelector('.header-section') || document.querySelector('header.header') || document.body;
        // characterData: the app rewrites the counter's text node in place.
        new MutationObserver(syncHeader).observe(observeRoot, {
            childList: true,
            subtree: true,
            characterData: true,
        });

        // Cart-sync hooks only on the app's proxy page — everywhere else
        // the theme handles its own /cart/add calls and refreshes itself
        // (hooking globally would double-refresh those).
        if (window.location.pathname.indexOf('/apps/page/wishlist') === 0) {
            hookFetch();
            hookXhr();
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
